import React from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedTabs } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

interface NavigationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
  /**
   * When true (tenant Pick'em full navigation enabled), shows Lobby, My Picks,
   * Recent, Leaderboard — Figma 10203:54359.
   * Otherwise only My Picks and Leaderboard.
   */
  fullNavigation?: boolean;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onTabChange,
  className = '',
  fullNavigation = false,
}) => {
  const { t } = useTranslation();

  const tabs = fullNavigation
    ? [
        { id: 'lobby', label: t('tabs.lobby') },
        { id: 'myPicks', label: t('tabs.myPicks') },
        { id: 'recent', label: t('tabs.recent') },
        { id: 'leaderboard', label: t('tabs.leaderboard') },
      ]
    : [
        { id: 'myPicks', label: t('tabs.myPicks') },
        { id: 'leaderboard', label: t('tabs.leaderboard') },
      ];

  const value = tabs.some(tab => tab.id === activeTab) ? activeTab : (tabs[0]?.id ?? activeTab);

  return (
    <SegmentedTabs
      className={cn('w-full', className)}
      value={value}
      onValueChange={onTabChange}
      aria-label={t('navigation.mainNav')}
      items={tabs.map(tab => ({
        value: tab.id,
        label: tab.label,
        'data-test-id': `nav-tab-${tab.id}`,
      }))}
    />
  );
};

export default NavigationTabs;
